import { api } from "./client";
import { apiRoutes } from "util/apiRoutes";
import { Issue } from "util/constants";

export const issueApi = {
  getById: async (issueId: number): Promise<Issue> => {
    const response = await api.get<Issue>(apiRoutes.issues.byId(issueId));
    return response.data;
  },
  getByCname: async (cname: string): Promise<Issue> => {
    const response = await api.get<Issue>(apiRoutes.issues.byName(cname));
    return response.data;
  },
  getInfluencesCount: async (issueId: number): Promise<number> => {
    const response = await api.get(apiRoutes.issues.influences(issueId), {
      params: { limit: 1 },
    });
    return Number(response.data?.total || 0);
  },
};

